import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {SignUtils} from "../../../core/utils/sign.utils";
import {MatTab, MatTabGroup, MatTabLabel} from "@angular/material/tabs";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-sign',
    templateUrl: './sign.component.html',
    imports: [
        MatTabGroup,
        MatTab,
        TranslatePipe,
        MatTabLabel
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./sign.component.scss']
})
export class SignComponent implements OnInit {

    // Utils
    signUtils = new SignUtils();

    signTabIndex = 0;

    signs: string [] = ["aries", "taurus", "gemini", "cancer", "leo", "virgo", "libra", "scorpio", "sagittarius", "capricorn", "aquarius", "pisces"]

    constructor(
        @Inject(MAT_DIALOG_DATA) public signId: string
    ) {
    }

    ngOnInit(): void {
        this.initActiveTab();
    }

    getGardenId() {
        const activeSignId = this.getActiveSign()
        return this.signUtils.getGardenForSign(activeSignId);
    }

    getElement(): string {
        const activeSignId = this.getActiveSign()
        return this.signUtils.getElementForSign(activeSignId);
    }

    getGarden(): string {
        const activeSignId = this.getActiveSign()
        return this.signUtils.getGardenForSign(activeSignId);
    }

    getOrganSystem(): string {
        const activeSignId = this.getActiveSign()
        return this.signUtils.getOrganSystemForSign(activeSignId);
    }

    getNutritionQuality(): string {
        const activeSignId = this.getActiveSign()
        return this.signUtils.getNutritionQualityForSign(activeSignId);
    }

    getDayQuality(): string {
        const activeSignId = this.getActiveSign()
        return this.signUtils.getDayQualityForSign(activeSignId);
    }

    getActiveSign(): string {
        return this.signs[this.signTabIndex]
    }

    private initActiveTab() {
        this.signTabIndex = this.signs.indexOf(this.signId, 0)
    }
}
